import { render, staticRenderFns } from "./Tugendhat.vue?vue&type=template&id=03e37cc6&scoped=true&"
import script from "./Tugendhat.vue?vue&type=script&lang=js&"
export * from "./Tugendhat.vue?vue&type=script&lang=js&"
import style0 from "./Tugendhat.vue?vue&type=style&index=0&id=03e37cc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e37cc6",
  null
  
)

export default component.exports